import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import ImageInfo from '@/app/editor/sidebar/elementsInfo/image';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'image',
    targetSelector: '.gf_image',
    property: 'src',
    relatedField: 'image-size',
  },
  {
    type: 'html:attr',
    name: 'image-size',
    targetSelector: 'self',
    property: 'data-resolution',
    relatedField: 'image',
  },
  {
    type: 'html:attr',
    name: 'title',
    targetSelector: '.gf_image',
    property: 'title',
  },
  {
    type: 'html:autoWrapLink',
    name: 'editLink',
    targetSelector: '.gf_image',
    property: 'href',
  },
  {
    type: 'html:attr',
    name: 'url-target',
    targetSelector: 'a',
    property: 'target',
  },
  {
    type: 'html:attr',
    name: 'alt-tag',
    targetSelector: '.gf_image',
    property: 'alt',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: '',
  },
  {
    type: 'css',
    name: 'width',
    default_value: 'auto',
    targetSelector: '.gf_image',
    property: 'width',
  },
  {
    type: 'css',
    name: 'height',
    default_value: 'auto',
    targetSelector: '.gf_image',
    property: 'height',
  },
  {
    type: 'css',
    name: 'circle',
    targetSelector: '.gf_image',
    property: 'border-radius',
    default_value: '',
    options: [
      {
        key: '0',
        value: '',
      },
      {
        key: '1',
        value: '100%',
      },
    ],
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * Image Atom Element
 */
export class GpImage extends GpElement {
  public $el: JQuery;

  /**
   * [Hook]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : ImageInfo.settings;
  }

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || ImageInfo.name;
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-key') || ImageInfo.slug;
  }

  /**
   * getClassName
   * @returns Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + ImageInfo.class;
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
